"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
var PortalRegistry = /*#__PURE__*/function () {
  function PortalRegistry() {
    this.containers = {};
    this.children = {};
    // Unique key for children of a portal
    this.currentId = 0;
  }
  var _proto = PortalRegistry.prototype;
  _proto.addContainer = function addContainer(name, container) {
    this.containers[name] = container;
    this.renderContainer(name);
  };
  _proto.removeContainer = function removeContainer(name) {
    delete this.containers[name];
  };
  _proto.addChild = function addChild(name, portalId, child) {
    this.children[name][portalId] = child;
    this.renderContainer(name);
  };
  _proto.clearChild = function clearChild(name, portalId) {
    delete this.children[name][portalId];
  };
  _proto.register = function register(name, child) {
    var portalId = name + "_" + this.currentId;
    this.children[name] = this.children[name] || {};
    this.children[name][portalId] = child;
    this.currentId += 1;
    return portalId;
  };
  _proto.unregister = function unregister(name, portalId) {
    this.clearChild(name, portalId);
    this.renderContainer(name);
  };
  _proto.renderContainer = function renderContainer(name) {
    var _this = this;
    if (this.containers[name] && this.children[name]) {
      this.containers[name].setState({
        children: Object.keys(this.children[name]).sort().map(function (id) {
          return /*#__PURE__*/(0, _react.cloneElement)(_this.children[name][id], {
            key: id
          });
        })
      });
    }
  };
  return PortalRegistry;
}();
var _default = exports.default = PortalRegistry;